export enum INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES {
  Item = 'Item',
  Category = 'Category',
  UOM = 'UOM',
  Count = 'Count',
}

export enum INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES {
  Item = 'item',
  Category = 'category',
  UOM = 'uom',
  Count = 'count',
}

export const INVENTORY_COUNT_GROUP_PDF_HEADERS = [
  {
    headerText: INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES.Item,
    dataKey: INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES.Item,
  },
  {
    headerText: INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES.Category,
    dataKey: INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES.Category,
  },
  {
    headerText: INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES.UOM,
    dataKey: INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES.UOM,
  },
  {
    headerText: INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES.Count,
    dataKey: INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES.Count,
  },
  {
    headerText: INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES.UOM,
    dataKey: INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES.UOM,
  },
  {
    headerText: INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES.Count,
    dataKey: INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES.Count,
  },
  {
    headerText: INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES.UOM,
    dataKey: INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES.UOM,
  },
  {
    headerText: INVENTORY_COUNT_GROUP_PDF_HEADER_NAMES.Count,
    dataKey: INVENTORY_COUNT_GROUP_PDF_HEADER_VALUES.Count,
  },
];
